import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core';


class BotaoEnviaJson extends Component {

    enviar() {
        const { dados, meta, tipoModelo } = this.props;

        this.props.setJsonGerarOkReportDeveloper(dados, meta)
        if (tipoModelo) {
            this.props.history.push({
                pathname: "/OkReportDeveloperForm",
                state: { tipoModelo }
            })
        } else {
            this.props.history.push("/OkReportDeveloperForm")
        }
    }
    render() {
        const { texto } = this.props;
        return (<Button
            variant="contained"
            color="primary"
            style={{ margin: 10 }}
            onClick={() => this.enviar()} >
            {texto ? texto : "Enviar Json para Developer"}
        </Button>
        )
    }
}

BotaoEnviaJson.propTypes = {
    setJsonGerarOkReportDeveloper: PropTypes.func.isRequired
}
export default BotaoEnviaJson;



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/BotaoEnviaJson/BotaoEnviaJson.js